import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import { HOST_TASKS_SERVICE } from '../Constants'
import { useGraphQLClient } from './useGraphQLClient'

export const useHostTasksClient = (): ApolloClient<NormalizedCacheObject> => {
  return useGraphQLClient({ clientUri: HOST_TASKS_SERVICE })
}
